import { createContext } from "react";
const TableContext = createContext(false);
const TableHeaderContext = createContext(false);
const TableBodyContext = createContext(false);
const TableFooterContext = createContext(false);
const TableRowContext = createContext(false);
export {
  TableBodyContext,
  TableContext,
  TableFooterContext,
  TableHeaderContext,
  TableRowContext
};
